import {FlexProps} from '@chakra-ui/react';
import React, {memo} from 'react';
import {Col, Row, UiButton} from '~/components/elements';
import {Option} from '~/types/models/questionnaire';

interface Props extends FlexProps {
  selectOptions?: Option[];
  noneOption?: Option;
  selectedOptions?: Record<string, boolean>;
  noneOptionSelected?: boolean;
  onClickOption?: (answer: Option) => void;
  onClickNoneOption?: () => void;
  itemSpacing?: number;
}

export const MultipleChipSelect = memo(function MultipleChipSelect({
  selectOptions = [],
  noneOption,
  selectedOptions = {},
  noneOptionSelected,
  onClickOption,
  onClickNoneOption,
  itemSpacing = 2.5,
  ...rest
}: Props) {
  // const noneOption = selectOptions.find(i => i.value === NONE_VALUE);

  // const selectOptions = options.filter(i => i.value !== NONE_VALUE);

  return (
    <Col {...rest}>
      <Row flexWrap="wrap" justifyContent={{base: 'left', lg: 'center'}} alignItems="center">
        {selectOptions.map((option, index) => {
          return (
            <UiButton
              key={option.key}
              height={9}
              borderRadius="1.25rem"
              variant={selectedOptions[option.value] ? 'solid' : 'outline'}
              size="lg"
              py={2.5}
              px={{base: option.label.length > 50 ? 2 : 4, md: 4}}
              mr={itemSpacing}
              mb={4}
              fontSize="xs"
              fontWeight="600"
              color="trueBlack"
              borderColor={selectedOptions[option.value] ? 'lightBaseColor' : 'trueBlack'}
              lineHeight="0.875rem"
              whiteSpace="pre-wrap"
              borderWidth={1}
              _hover={{}}
              onClick={() => onClickOption?.(option)}
            >
              {option.label}
            </UiButton>
          );
        })}
      </Row>
      {noneOption && (
        <Col alignItems="center" justifyContent="center" my="2vh">
          <UiButton
            height={12}
            borderRadius="3rem"
            variant={noneOptionSelected ? 'solid' : 'outline'}
            size="lg"
            py={3}
            px={7}
            mr={2.5}
            fontSize="sm"
            fontWeight="600"
            color="trueBlack"
            borderColor={noneOptionSelected ? 'lightBaseColor' : 'trueBlack'}
            maxW={36}
            whiteSpace="pre-wrap"
            lineHeight="0.875rem"
            _hover={{}}
            onClick={onClickNoneOption}
          >
            {noneOption.label}
          </UiButton>
        </Col>
      )}
    </Col>
  );
});
